import { combineReducers } from '@reduxjs/toolkit';
import list from './notificationsSlice';
import hubConnection from './notificationsHubSlice';
import pushSubscription from './pushSubscriptionSlice';

const notificationsReducers = combineReducers({
	list,
	hubConnection,
	pushSubscription
});

export default notificationsReducers;
